import React from "react";
import PropTypes from "kf-proptypes/widgets";

import { FlowIcon } from "./flowicon.jsx";
import { ICON_URL } from "@widgets/inputs/index.jsx";

import styles from "./flowicon.css";

FlowIconWrapper.propTypes = {
  flow: PropTypes.shape({ _id: PropTypes.string }),
  size: PropTypes.string
};

export function FlowIconWrapper({ flow = {}, size, ...rest }) {
  let icons = {
    chat: "Chat",
    announcements: "Announcement"
  };
  if (icons[flow._id]) {
    return (
      <div className={`${styles[size]} ${styles.iconContainerSystem}`}>
        <img
          src={`${ICON_URL}/${icons[flow._id]}/${icons[flow._id]}.svg`}
          alt={flow._id}
        />
      </div>
    );
  } else {
    return <FlowIcon size={size} {...rest} />;
  }
}
